// extracted by mini-css-extract-plugin
export default {"title":"style_title__IWSiw","card-msg-item-icon":"style_card-msg-item-icon__RqCZC"};